import { useEffect, useState } from "react";
import makeAnimated from "react-select/animated";
import Select from "react-select";

import DatePicker from "react-datepicker";
import isValid from "date-fns/isValid";
import subDays from "date-fns/subDays";
import addDays from "date-fns/addDays";
import format from "date-fns/format";
import "react-datepicker/dist/react-datepicker.css";

import useReport from "../../Hooks/useReport";
import useCompany from "../../Hooks/useCompany";

import { Card, CardBody } from "../../Components/Card";
import { Text } from "../../Components/Text";
import { Column, Row } from "../../Components/Layout";
import { Button } from "../../Components/Button";

const Filters = () => {
  const animatedComponents = makeAnimated();

  const { listCompany } = useCompany();
  const { indexProspectList } = useReport();

  const today = new Date();

  const [startDate, setStartDate] = useState(today.setDate(1));
  const [validStartDate, setValidStartDate] = useState("");

  const [endDate, setEndDate] = useState(
    new Date(today.getFullYear(), today.getMonth() + 1, 0)
  );
  const [validEndDate, setValidEndDate] = useState("");

  const [unit, setUnit] = useState();
  const [listUnits, setListUnits] = useState([]);
  const [validUnits, setValidUnits] = useState("");

  const [status, setStatus] = useState({ value: 1, label: "Ativo" });
  const [listStatus] = useState([
    { value: 1, label: "Ativo" },
    { value: 0, label: "Inativo" },
  ]);

  useEffect(() => {
    if (listCompany) {
      setListUnits(listCompany);
    }
  }, [listCompany]);

  const handleStartDateChange = (date) => {
    setStartDate(date);
    setValidStartDate(isValid(date) ? "" : "Data inválida");
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
    setValidEndDate(isValid(date) ? "" : "Data inválida");
  };

  const handleCompany = (e) => {
    setUnit(e);
    setValidUnits(e ? "" : "Selecione uma empresa");
  };

  const handleValidate = () => {
    let valid = true;

    if (!isValid(startDate)) {
      setValidStartDate("Data inicial inválida");
      valid = false;
    } else {
      setValidStartDate("");
    }

    if (!isValid(endDate)) {
      setValidEndDate("Data final inválida");
      valid = false;
    } else {
      setValidEndDate("");
    }

    if (!unit || unit.value === undefined) {
      setValidUnits("Selecione uma empresa");
      valid = false;
    } else {
      setValidUnits("");
    }

    return valid;
  };

  const handleFilter = () => {
    if (handleValidate()) {
      let params = {
        start_date: format(startDate, "yyyy-MM-dd"),
        end_date: format(endDate, "yyyy-MM-dd"),
        company: unit.value,
        status: status.value,
      };

      indexProspectList(params);
    }
  };

  return (
    <Card bgColor="white" marginBottom="3" padding="2">
      <CardBody>
        <Row>
          <Column col="6" md="2">
            <Text tag="h6">Data Início</Text>
            <DatePicker
              locale="ptBR"
              selected={startDate}
              onChange={(date) => handleStartDateChange(date)}
              onBlur={() => handleStartDateChange(startDate)}
              dateFormat="dd/MM/yyyy"
              portalId="root"
              className={
                validStartDate
                  ? "form-control is-invalid bg-white"
                  : "form-control bg-white"
              }
              maxDate={endDate}
              minDate={subDays(endDate, 60)}
            />
            {validStartDate && (
              <div className="invalid-feedback">{validStartDate}</div>
            )}
          </Column>
          <Column col="6" md="2">
            <Text tag="h6">Data Final</Text>
            <DatePicker
              locale="ptBR"
              selected={endDate}
              onChange={(date) => handleEndDateChange(date)}
              onBlur={() => handleEndDateChange(endDate)}
              dateFormat="dd/MM/yyyy"
              portalId="root"
              className={
                validEndDate
                  ? "form-control is-invalid bg-white"
                  : "form-control bg-white"
              }
              minDate={startDate}
              maxDate={addDays(startDate, 60)}
            />
            {validEndDate && (
              <div className="invalid-feedback">{validEndDate}</div>
            )}
          </Column>
          <Column col="12" md="4">
            <Text tag="h6">Unidades</Text>
            <Select
              closeMenuOnSelect={true}
              components={animatedComponents}
              value={unit}
              options={listUnits}
              onChange={handleCompany}
              menuPosition={"fixed"}
              className={validUnits && "form-control is-invalid bg-white"}
            />
            {validUnits && <div className="invalid-feedback">{validUnits}</div>}
          </Column>
          <Column col="12" md="2">
            <Text tag="h6">Status</Text>
            <Select
              closeMenuOnSelect={true}
              components={animatedComponents}
              defaultValue={[{ value: 1, label: "Ativo" }]}
              value={status}
              options={listStatus}
              menuPosition={"fixed"}
              onChange={(e) => setStatus(e)}
            />
          </Column>
          <Column col="12" md="2" top marginTop="3">
            <Button
              txtAlign="center"
              bgColor="info"
              width
              txtColor="white"
              marginTop="2"
              onClick={handleFilter}
              id="btn-filter-campaign"
            >
              <Text tag="i" className="fa fa-file-download" marginRight="2" />
              <Text tag="small">Filtrar</Text>
            </Button>
          </Column>
        </Row>
      </CardBody>
    </Card>
  );
};

export default Filters;
